import React, { useState,useEffect } from 'react'
import { Button } from 'primereact/button';
import "../Registration/ShowRegisterData.scss"
import { InputText } from 'primereact/inputtext';
import axios from 'axios';
import { putRegisterurl } from '../../Services/BackendUrl';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { getNames } from "country-list";
import { encryptedAuth } from '../../Services/EncryptData';


const ShowRegisteredData = ({ customer, 
    isShowEditMode, 
    setIsShowEditMode, 
    setShowDetails, 
     getMembershipurl, 
     setRegisteredCustomers, 
     setIsExporting ,
     isShowSearch, isShowEditIcon}

    ) => {


    const [formData, setFormData] = useState(customer);
    const [isEditMode, setIsEditMode] = useState(false);
    const [showFilePreview, setShowFilePreview] = useState(false);
    const [showCivilIDPreview, setShowCivilIDPreview] = useState(false);

    useEffect(() => {
  setFormData({
    ...customer,
    dateOfBirth: customer.dateOfBirth ? new Date(customer.dateOfBirth) : null,
    preferredStartDate:customer.preferredStartDate ? new Date(customer.preferredStartDate) : null
  });
}, [customer]);

 const countries = getNames().map((country) => ({ name: country }));
  const bloodGroups = [
  "A+",
  "A−",
  "B+",
  "B−",
  "AB+",
  "AB−",
  "O+",
  "O−"
];
 const membershipOptions = [
    "ONE Hour Slot per player",
    "ONE Hour Slot, ONE Court, for max 6 players",
    "Weekly (5days), for ONE player",
    "Weekly (5 Days), ONE Court, for max 6 players",
    "Monthly (Excluding Week Ends), ONE player",
    "Monthly (Excluding Week Ends), ONE Court, for max 6 players",
    "Monthly, only Week-Ends (Fri & Sat), ONE Court, for max 6 player",
    "Yearly (Excluding Week Ends), ONE player",
    "Yearly (Excluding Week Ends), ONE Court, for max 6 players",
    "Yearly (Including Week Ends), ONE Court, for max 6 players",
  ];

    const forceBypassCache = (url) => {
        if (!url) return '';
        return `${url}?t=${new Date().getTime()}`;
    };

    const getFileName = (input) => {
        if (!input) return '';


        if (typeof input === 'object' && input.name) {
            return input.name;
        }


        if (typeof input === 'string') {
            return input.split('/').pop();
        }

        return '';
    };



    const handleFileChange = (e, field) => {
        const file = e.target.files[0];
        if (file) {
            setFormData(prev => ({
                ...prev,
                [field]: file,
            }));
        }
    };

    const fetchRegisteredcustomers = async () => {
        try {
            const response = await axios.get(getMembershipurl,
                {
                    headers: {
                        Authorization : `Encrypted ${encryptedAuth}`
                    }
                }
            )
            setRegisteredCustomers(response.data.users)

        }
        catch (error) {
            console.error('Error fetching users:', error);

        }
        finally {
            setIsExporting(false)
        }
    }




    const updateRegisteredData = async () => {

        try {

            const updateData = {
                firstName: formData.firstName,
                lastName: formData.lastName,
                emailAddress: formData.emailAddress,
                phoneNumber: formData.phoneNumber,
                whatsAppNumber: formData.whatsAppNumber,
                dateOfBirth: formData.dateOfBirth,
                gender: formData.gender,
                address: formData.address,
                address2: formData.address2,
                city: formData.city,
                state: formData.state,
                zipcode: formData.zipcode,
                country: formData.country,
                civilIdNumber: formData.civilIdNumber,
                idExpireDate: formData.idExpireDate,
                emergencyContactFirstName: formData.emergencyContactFirstName,
                emergencyContactLastName: formData.emergencyContactLastName,
                emergencyContactRelationship: formData.emergencyContactRelationship,
                emergencyContactPhoneNumber: formData.emergencyContactPhoneNumber,
                medicalCondition: formData.medicalCondition,
                bloodGroup: formData.bloodGroup,
                medicalConditionDetails: formData.medicalConditionDetails,
                membershipType: formData.membershipType,
                preferredStartDate: formData.preferredStartDate,
            }

            const updatedData = new FormData();

            updatedData.append('data', JSON.stringify(updateData));
            updatedData.append('photoProof', formData.photoProof);
            updatedData.append('civilIdImage', formData.civilIdImage);




            await axios.put(`${putRegisterurl}/${formData.userId}`, updatedData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization : `Encrypted ${encryptedAuth}`
                },
            })
            alert('Updated successfully!');
            await fetchRegisteredcustomers()
            setIsEditMode(false);
            setIsShowEditMode(false);
            setShowDetails(false)
            setShowFilePreview(false)
            isShowSearch(true)


        }

        catch (error) {
            console.error('Error updating user:', error.response?.data || error.message);
        }
    }

    return (
        <>
            <div className="showregisterdata-container">
                <div className={`registerdata-title-container ${isEditMode || isShowEditMode ? 'editmode-active' : ''}`}>
                    <h3>PERSONAL INFORMATION</h3>
                    {isShowEditIcon && <Button label="Edit" icon="pi pi-file-edit" iconPos="right" onClick={() => setIsEditMode(!isEditMode)} className={`registerdata-btn ${isEditMode ? 'editmode-active' : ''}`} />}
                </div>
                <div className="customer-details-grid ">
                    <div className="detail-item"><strong>First Name</strong>
                        {isEditMode || (isShowEditMode) ? (
                            <div className="custom-input">
                                <InputText value={formData.firstName} onChange={(e) => setFormData({ ...formData, firstName: e.target.value })} />
                            </div>
                        ) : (
                            <div>{customer.firstName}</div>
                        )}

                    </div>
                    <div className="detail-item"><strong>Last Name</strong>
                        {isEditMode || isShowEditMode ? (
                            <div className="custom-input">
                                <InputText value={formData.lastName} onChange={(e) => setFormData({ ...formData, lastName: e.target.value })} />
                            </div>
                        ) : (
                            <div>{customer.lastName}</div>
                        )}

                    </div>
                    <div className="detail-item"><strong>Email Address</strong>
                        {isEditMode || isShowEditMode ? (
                            <div className="custom-input">
                                <InputText value={formData.emailAddress} onChange={(e) => setFormData({ ...formData, emailAddress: e.target.value })} />
                            </div>
                        ) : (
                            <div>{customer.emailAddress}</div>
                        )}

                    </div>
                    <div className="detail-item"><strong>Phone Number</strong>
                        {isEditMode || isShowEditMode ? (
                            <div className="custom-input">
                                <InputText value={formData.phoneNumber} onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })} />
                            </div>
                        ) : (
                            <div>{customer.phoneNumber}</div>
                        )}

                    </div>
                    <div className="detail-item"><strong>Whatsapp Number</strong>
                        {isEditMode || isShowEditMode ? (
                            <div className="custom-input">
                                <InputText value={formData.whatsAppNumber} onChange={(e) => setFormData({ ...formData, whatsAppNumber: e.target.value })} />
                            </div>
                        ) : (
                            <div>{customer.whatsAppNumber}</div>
                        )}

                    </div>
                    <div className="detail-item"><strong>Date of Birth</strong>
                        {isEditMode || isShowEditMode ? (
                            // <div className="custom-input">
                            //     <InputText type='date' value={formData.dateOfBirth} onChange={(e) => setFormData({ ...formData, dateOfBirth: e.target.value })} />
                            // </div>
                            <div className="card flex flex-wrap gap-3 p-fluid">
                                <div className="flex-auto kba-calender">
                                    <Calendar style={{ width: "70%", height: "35px", borderRadius: "10px", outline: "none", color: "white" }} value={formData.dateOfBirth} onChange={(e) => setFormData({ ...formData,dateOfBirth : e.value })} showIcon dateFormat='dd-mm-yy' />
                                </div>
                            </div>
                        ) : (
                            <div>{new Date(customer.dateOfBirth).toLocaleDateString('en-GB').replace(/\//g, '-')}</div>
                        )}

                    </div>
                    <div className="detail-item"><strong>Gender</strong>
                        {isEditMode || isShowEditMode ? (
                            <div className="custom-input">
                                <InputText value={formData.gender} onChange={(e) => setFormData({ ...formData, gender: e.target.value })} />
                            </div>
                        ) : (
                            <div>{customer.gender}</div>
                        )}
                    </div>
                    <div className="detail-item"><strong>Address<span style={{ color: "#838383", fontSize: "14px" }}> (Street address)</span></strong>
                        {isEditMode || isShowEditMode ? (
                            <div className="custom-input">
                                <InputText value={formData.address} onChange={(e) => setFormData({ ...formData, address: e.target.value })} />
                            </div>
                        ) : (
                            <div>{customer.address}</div>
                        )}
                    </div>
                    {/* <div className="detail-item"><strong>Address<span style={{ color: "#838383", fontSize: "14px" }}> (Street address)</span></strong>
                        {isEditMode || isShowEditMode ? (
                            <div className="custom-input">
                                <InputText value={formData.address2} onChange={(e) => setFormData({ ...formData, address2: e.target.value })} />
                            </div>
                        ) : (
                            <div>{customer.address2}</div>
                        )}
                    </div> */}
                    <div className="detail-item"><strong>City Name</strong>
                        {isEditMode || isShowEditMode ? (
                            <div className="custom-input">
                                <InputText value={formData.city} onChange={(e) => setFormData({ ...formData, city: e.target.value })} />
                            </div>
                        ) : (
                            <div>{customer.city}</div>
                        )}
                    </div>
                    <div className="detail-item"><strong>State/Province</strong>
                        {isEditMode || isShowEditMode ? (
                            <div className="custom-input">
                                <InputText value={formData.state} onChange={(e) => setFormData({ ...formData, state: e.target.value })} />
                            </div>
                        ) : (
                            <div>{customer.state}</div>
                        )}
                    </div>
                    <div className="detail-item"><strong>Postal/Zip Code</strong>
                        {isEditMode || isShowEditMode ? (
                            <div className="custom-input">
                                <InputText value={formData.zipcode} onChange={(e) => setFormData({ ...formData, zipcode: e.target.value })} />
                            </div>
                        ) : (
                            <div>{customer.zipcode}</div>
                        )}
                    </div>
                    {/* <div className="detail-item"><strong>Country</strong>
                        {isEditMode || isShowEditMode ? (
                            <div className="custom-input">
                                <InputText value={formData.country} onChange={(e) => setFormData({ ...formData, country: e.target.value })} />
                            </div>
                        ) : (
                            <div>{customer.country}</div>
                        )}
                    </div> */}
                    <div className="detail-item">
                        <strong>Country</strong>
                        {isEditMode || isShowEditMode ? (
                            <div className="custom-input">
                                <Dropdown
                                    value={countries.find(c => c.name === formData.country)}
                                    onChange={(e) => setFormData({ ...formData, country: e.value.name })}
                                    options={countries}
                                    optionLabel="name"
                                    className="w-full md:w-14rem"
                                />
                            </div>
                        ) : (
                            <div>{customer.country}</div>
                        )}
                    </div>
                    <div className="detail-item"><strong>Civil ID Number</strong>
                        {isEditMode || isShowEditMode ? (
                            <div className="custom-input">
                                <InputText value={formData.civilIdNumber} onChange={(e) => setFormData({ ...formData, civilIdNumber: e.target.value })} />
                            </div>
                        ) : (
                            <div>{customer.civilIdNumber}</div>
                        )}
                    </div>
                    <div className="detail-item"><strong>ID Expiry Date</strong>
                        {isEditMode || isShowEditMode ? (
                            // <div className="custom-input">
                            //     <InputText type='date' value={formData.idExpireDate}  onChange={(e) => setFormData({ ...formData, idExpireDate: e.target.value })} />

                            // </div>

                            <div className="card flex flex-wrap gap-3 p-fluid">
                                <div className="flex-auto kba-calender">
                                    <Calendar style={{ width: "70%", height: "35px", borderRadius: "10px", outline: "none", color: "white" }} value={new Date(formData.idExpireDate)} onChange={(e) => setFormData({ ...formData, idExpireDate: e.target.value })} showIcon dateFormat='dd-mm-yy' />
                                </div>
                            </div>
                        ) : (
                            <div>{new Date(customer.idExpireDate).toLocaleDateString('en-GB').replace(/\//g, '-')}</div>
                        )}
                    </div>

                    <div className="detail-item">
                        <strong>Photo Proof</strong>

                        {
                            // exportType === 'pdf' ? (
                            //     <div className="proof-url">
                            //         {customer?.photoProof || 'N/A'}
                            //     </div>
                            // ) :
                             isEditMode || isShowEditMode ? (
                                <div className="proof-wrapper">
                                    <Button
                                        icon="pi pi-plus"
                                        className="plus-btn"
                                        onClick={() => document.getElementById('photoProofInput').click()}
                                    />
                                    <input
                                        id="photoProofInput"
                                        type="file"
                                        accept="image/*"
                                        style={{ display: 'none' }}
                                        onChange={(e) => {
                                            handleFileChange(e, 'photoProof');
                                            if (e.target.files?.length > 0)
                                                setShowFilePreview(true);
                                        }}
                                    />
                                    {showFilePreview ? (
                                        <div className="proof-btn-edit">
                                            <Button
                                                label={getFileName(formData?.photoProof)}
                                                icon="pi pi-file"
                                                // onClick={() => window.open(formData?.photoProof, '_blank')}
                                                className="file-display-btn"
                                            />
                                        </div>
                                    ) : (
                                        <div className="proof-btn-edit">
                                            <Button
                                                label={getFileName(customer?.photoProof)}
                                                icon="pi pi-file"
                                                // onClick={() => { window.open(customer?.photoProof, '_blank') }}
                                                severity="info"
                                            />
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="proof-btn">
                                    <Button
                                        label={getFileName(customer?.photoProof)}
                                        icon="pi pi-file"
                                        onClick={() => { window.open(forceBypassCache(customer?.photoProof), '_blank'); }}
                                        severity="info"
                                    />
                                </div>
                            )
                        }
                    </div>

                    <div className="detail-item">
                        <strong>Civil ID Image</strong>

                        {
                        // exportType === 'pdf' ? (
                        //     <div className="proof-url">
                        //         {customer?.civilIdImage || 'N/A'}
                        //     </div>
                        // ) : 
                        isEditMode || isShowEditMode ? (
                            <div className="proof-wrapper">
                                <Button
                                    icon="pi pi-plus"
                                    className="plus-btn"
                                    onClick={() => document.getElementById('civilIdInput').click()}
                                    style={{ marginLeft: "40px" }}
                                />
                                <input
                                    id="civilIdInput"
                                    type="file"
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    onChange={(e) => {
                                        handleFileChange(e, 'civilIdImage');
                                        if (e.target.files?.length > 0) {
                                            setShowCivilIDPreview(true);
                                        }
                                    }}
                                />
                                {showCivilIDPreview ? (
                                    <div className="proof-btn-edit">
                                        <Button
                                            label={getFileName(formData?.civilIdImage || '')}
                                            icon="pi pi-file"
                                            onClick={() => window.open(formData?.civilIdImage, '_blank')}
                                            className="file-display-btn"
                                        />
                                    </div>
                                ) : (
                                    <div className="proof-btn-edit">
                                        <Button
                                            label={getFileName(customer?.civilIdImage)}
                                            icon="pi pi-file"
                                            onClick={() => window.open(customer?.civilIdImage, '_blank')}
                                            severity="info"
                                        />
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="proof-btn">
                                <Button
                                    label={getFileName(customer?.civilIdImage)}
                                    icon="pi pi-file"
                                    onClick={() => window.open(forceBypassCache(customer?.civilIdImage), '_blank')}
                                    severity="info"
                                />
                            </div>
                        )}
                    </div>

                </div>
                <div className='registerdata-title-container'>
                    <h3>EMERGENCY CONTACT INFORMATION</h3>
                </div>
                <div>
                    <div className="customer-details-grid">
                        <div className="detail-item"><strong>Emergency Contact Name</strong>
                            {isEditMode || isShowEditMode ? (
                                <div className="custom-input">
                                    <InputText value={formData.emergencyContactFirstName} onChange={(e) => setFormData({ ...formData, emergencyContactFirstName: e.target.value })} />
                                </div>
                            ) : (
                                <div>{customer.emergencyContactFirstName}</div>
                            )}
                        </div>
                        {/* <div className="detail-item"><strong>Last Name</strong>
                            {isEditMode || isShowEditMode ? (
                                <div className="custom-input">
                                    <InputText value={formData.emergencyContactLastName} onChange={(e) => setFormData({ ...formData, emergencyContactLastName: e.target.value })} />
                                </div>
                            ) : (
                                <div>{customer.emergencyContactLastName}</div>
                            )}
                        </div> */}
                        <div className="detail-item"><strong>Relationship</strong>
                            {isEditMode || isShowEditMode ? (
                                <div className="custom-input">
                                    <InputText value={formData.emergencyContactRelationship} onChange={(e) => setFormData({ ...formData, emergencyContactRelationship: e.target.value })} />
                                </div>
                            ) : (
                                <div>{customer.emergencyContactRelationship}</div>
                            )}
                        </div>
                        <div className="detail-item"><strong>Phone Number</strong>
                            {isEditMode || isShowEditMode ? (
                                <div className="custom-input">
                                    <InputText value={formData.emergencyContactPhoneNumber} onChange={(e) => setFormData({ ...formData, emergencyContactPhoneNumber: e.target.value })} />
                                </div>
                            ) : (
                                <div>{customer.emergencyContactPhoneNumber}</div>
                            )}
                        </div>
                    </div>
                </div>

                <div className='registerdata-title-container'>
                    <h3>MEDICAL INFORMATION</h3>
                </div>
                <div>
                    <div className="customer-medicaldetails-grid">
                        <div className="detail-item"><strong>Do you have any medical conditions or allergies?</strong>
                            {isEditMode || isShowEditMode ? (
                                <div className="custom-input">
                                    <InputText value={formData.medicalCondition} onChange={(e) => setFormData({ ...formData, medicalCondition: e.target.value })} />
                                </div>
                            ) : (
                                <div>{customer.medicalCondition}</div>
                            )}
                        </div>
                        <div className="detail-item"><strong>Blood Group</strong>
                            {isEditMode || isShowEditMode ? (
                                <div className="custom-input">
                                    {/* <InputText value={formData.bloodGroup} onChange={(e) => setFormData({ ...formData, bloodGroup: e.target.value })} /> */}
                                 <Dropdown
                                    value={bloodGroups.find(g => g === formData.bloodGroup)}
                                    onChange={(e) => setFormData({ ...formData, bloodGroup: e.value})}
                                    options={bloodGroups}
                                    optionLabel="name"
                                    className="w-full md:w-14rem"
                                />
                                </div>
                            ) : (
                                <div>{customer.bloodGroup}</div>
                            )}
                        </div>
                        
                        <div className="detail-item"><strong>If yes please provide details</strong>
                            {isEditMode || isShowEditMode ? (
                                <div className="custom-input">
                                    <InputText value={formData.medicalConditionDetails} onChange={(e) => setFormData({ ...formData, medicalConditionDetails: e.target.value })} />
                                </div>
                            ) : (
                                <div>{customer.medicalConditionDetails}</div>
                            )}
                        </div>

                    </div>
                </div>
                <div className='registerdata-title-container'>
                    <h3>MEMBERSHIP INFORMATION</h3>
                </div>
                <div>
                    <div className="customer-medicaldetails-grid">
                        <div className="detail-item"><strong>Preferred Start Date</strong>
                            {isEditMode || isShowEditMode ? (
                                <div className="card flex flex-wrap gap-3 p-fluid">
                                    <div className="flex-auto kba-calender">
                                        <Calendar style={{ width: "70%", height: "35px", borderRadius: "10px", outline: "none", color: "white" }} value={formData.preferredStartDate} onChange={(e) => setFormData({ ...formData, preferredStartDate: e.target.value })} showIcon dateFormat='dd-mm-yy' />
                                    </div>
                                </div>
                            ) : (
                                <div>{new Date(customer.preferredStartDate).toLocaleDateString('en-GB').replace(/\//g, '-')}</div>
                            )}
                        </div>
                        <div className="detail-item"><strong>Type of membership</strong>
                            {isEditMode || isShowEditMode ? (
                                <div className="custom-input">
                                    {/* <InputText value={formData.membershipType} onChange={(e) => setFormData({ ...formData, membershipType: e.target.value })} /> */}
                                 <Dropdown
                                    value={membershipOptions.find(m => m === formData.membershipType)}
                                    onChange={(e) => setFormData({ ...formData, membershipType: e.value})}
                                    options={membershipOptions}
                                    optionLabel="name"
                                    className="w-full md:w-14rem"
                                />
                                </div>
                            ) : (
                                <div>{customer.membershipType}</div>
                            )}
                        </div>

                    </div>
                </div>
                {isEditMode || isShowEditMode ?
                    (<div className='registerdata-submit'>
                        <Button label="Submit" onClick={updateRegisteredData} />
                    </div>) : null
                }
            </div>
        </>
    )
}


export default ShowRegisteredData